const OrderHistoryStatus = ({ value }) => {
	return (
		<div className={value === 'filled' ? 'green-value' : 'red-value'}>
			<span>{value}</span>
		</div>
	);
};

export default OrderHistoryStatus;
